// extracted by mini-css-extract-plugin
export default {"action":"styles_action__31FSD","checkmark":"styles_checkmark__Hoqwu","selected":"styles_selected__ri0e-"};